<template>
  <div>
    <router-link to="/cart/hotboom" class="cart">
      <h2 v-if="cartCount != ''">{{ cartCount }}</h2>
      <img src="../../assets/img/user_home/car.png" alt />
      <span>買い物かご</span>
    </router-link>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["cartCount"]),
  },
  created() {
    this.getCart();
  },
  methods: {
    ...mapActions(["getCart"]),
  },
};
</script>
<style lang='scss' scoped>
.cart {
  width: 138px;
  height: 40px;
  position: absolute;
  top: 50px;
  right: 148px;
  border-radius: 5px;
  background: #f3c622;


  h2 {
    position: absolute;
    top: 0px;
    left: 30px;
    width: 16px;
    height: 16px;
    background: #b4272d;
    line-height: 16px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    border-radius: 50%;
  }

  span {
    font-size: 14px;
    color: #222;
    line-height: 40px;
  }

  img {
    width: 24px;
    height: 24px;
    margin: 00px 7px 0 13px;
    vertical-align: middle;
  }
}
</style>